import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef} from '@angular/core';
import {CheckboxComponent} from '../checkbox/checkbox.component';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'tumbler',
    templateUrl: './tumbler.component.html',
    styleUrls: ['./tumbler.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TumblerComponent),
            multi: true,
        },
    ],
})
export class TumblerComponent extends CheckboxComponent {
    constructor($el: ElementRef<HTMLElement>, cd: ChangeDetectorRef) {
        super($el, cd);
    }
}
